import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import bg2 from "./31.png";
export default function Splash5({ onFinish }) {
  const [progress, setProgress] = useState(0);
  const [pendingNav, setPendingNav] = useState(null);
  const [forceProceed, setForceProceed] = useState(false);

  const navigate = useNavigate();
  const { user, isBootstrapping } = useAuth();

  // Animate progress bar to 100%
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((p) => (p < 100 ? p + 1 : 100));
    }, 50); // ~5s total
    return () => clearInterval(timer);
  }, []);

  // When progress completes, attempt navigation
  useEffect(() => {
    if (progress >= 100) attemptNavigate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progress]);

  // If waiting for auth to finish bootstrapping
  useEffect(() => {
    if (!isBootstrapping && pendingNav) performNavigation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBootstrapping, pendingNav]);

  // Fallback: do not block on splash forever if auth bootstrapping is slow in some browsers.
  useEffect(() => {
    const watchdog = setTimeout(() => {
      if (isBootstrapping) {
        setForceProceed(true);
      }
    }, 12000);

    return () => clearTimeout(watchdog);
  }, [isBootstrapping]);

  function decideDestination() {
    if (user) return "home";
    return "signin";
  }

  function performNavigation() {
    const dest = decideDestination();
    setPendingNav(null);
    if (dest === "home") navigate("/home");
    else if (dest === "signin") navigate("/signin");
    else navigate("/welcome");
  }



  function attemptNavigate() {

    if (isBootstrapping && !forceProceed) {
      setPendingNav(true);
      return;
    }

    // ✅ Notify parent splash sequence that this is done
    if (onFinish) onFinish();

    performNavigation();

   
  }

  return (
    <div
      onClick={attemptNavigate}
      style={{
        backgroundImage: `url(${bg2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        cursor: "pointer",
      }}
      className="d-flex flex-column justify-content-between align-items-center vh-100"
    />
  );
}
